const userRoles = {
  VOLUNTEER: 'VOLUNTEER',
  DIGITAL_CHAMPION: 'DIGITAL_CHAMPION',
  HQ: 'HQ',
};

export default userRoles;
